import React from 'react';

function Posts() {
  return (
    <main className="posts-page">
      <div className="posts-container">
        <h1>Posts</h1>
        <p>Posts page coming soon...</p>
      </div>
    </main>
  );
}

export default Posts;

